import { intersection as _intersection } from 'lodash';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import useAuth from '@helper/hooks/useAuth';

function PageRequireAdminTileAccess({
  roles = [],
  redirectURL = '/not-authorised',
  tileAccess,
  ...props
}) {
  const [isAuthenticated, setIsAuthenticated] = useState(undefined);

  const user = useAuth();

  useEffect(() => {
    if (user.isLoading) return;

    if (user.isLoggedIn) {
      const hasRoles = _intersection(user.Roles, roles);
      const hasTileAccess = user.TileAccess.includes(tileAccess);
      if (hasRoles && hasRoles.length > 0 && hasTileAccess) {
        setIsAuthenticated(true);
        return;
      }
    } else {
      setIsAuthenticated(true);
      return;
    }

    setIsAuthenticated(false);
  }, [roles, user.Roles, user.isLoading, user.isLoggedIn, user.TileAccess, tileAccess]);

  if (isAuthenticated === undefined || isAuthenticated === null) {
    return <></>;
  }

  if (isAuthenticated) {
    return props.children;
  } else {
    return (
      <Navigate
        to={{
          pathname: redirectURL,
        }}
      />
    );
  }
}

export default function RouteRequireAdminTileAccess({
  roles = [],
  redirectURL = '/not-authorised',
  tileAccess,
}) {
  return (
    <PageRequireAdminTileAccess roles={roles} redirectURL={redirectURL} tileAccess={tileAccess}>
      <Outlet />
    </PageRequireAdminTileAccess>
  );
}
